import { manageEditPool, manageEditPoolConfig } from './manage.editPool'

export default function manageEditPoolRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(manageEditPool, manageEditPoolConfig)
}
